export default __webpack_public_path__ + "static/media/garage.99a5caac.jpg";